export default () => {
    const domNode = document.getElementById('individual-drug-classes');
    if (domNode) {
        const drugClassTags = domNode.getElementsByTagName('p');

        for (let i = 0, len = drugClassTags.length; i < len; i++) {
            const drugClassTag = drugClassTags.item(i);
            if (drugClassTag) {
                const content = drugClassTag.innerHTML;

                const linkAnchorStart = 'href="';
                const linkLocation = content.indexOf(linkAnchorStart);
                if (linkLocation > 0) {
                    const linkStart = content.substring(
                        linkLocation + linkAnchorStart.length,
                    );
                    const linkComplete = linkStart.substring(
                        0,
                        linkStart.indexOf('"'),
                    );
                    void linkComplete;
                }

                // drugClassTag.innerHTML = `${content} | <a>pdf summary</a>`;
            }
        }
    }
};
